// @flow
import { handleResponseOld, makePost } from './helpers';

type PostCaptureBuyNowRequestParams = {
    authToken: string,
    deployment: string,
    details: any,
};

export default {
    postCaptureBuyNowRequest: ({ authToken, deployment, details }: PostCaptureBuyNowRequestParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ authToken, deployment, path: '<MARKETPLACE-API>capturebuynowrequest' });
            request.send(details);
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
